<template>
  <div>
    <!-- Projects Start -->
    <div class="container-xxl py-5">
      <div class="container">
        <div
          class="text-center mx-auto wow fadeInUp"
          data-wow-delay="0.1s"
          style="max-width: 500px"
        >
          <p class="fs-5 fw-bold text-primary">Unsere Projekte</p>
          <h1 class="display-5 mb-5">Einige unserer wunderbaren Projekte</h1>
        </div>
        <!-- <div class="row wow fadeInUp" data-wow-delay="0.3s">
          <div class="col-12 text-center">
            <ul class="list-inline rounded mb-5" id="portfolio-flters">
              <li class="mx-2 active" data-filter="*">All</li>
              <li class="mx-2" data-filter=".first">Complete Projects</li>
              <li class="mx-2" data-filter=".second">Ongoing Projects</li>
            </ul>
          </div>
        </div> -->
        <div class="row g-4 portfolio-container">
          <div
            class="col-lg-4 col-md-6 portfolio-item first wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div class="portfolio-inner rounded">
              <img
                class="img-fluid"
                src="img/work/project-paving.jpg"
                :alt="globalConfig.altPictureText"
              />
              <div class="portfolio-text">
                <h4 class="text-white mb-4">Gartengestaltung</h4>
                <div class="d-flex">
                  <a
                    class="btn btn-lg-square rounded-circle mx-2"
                    href="img/work/paving.jpg"
                    data-lightbox="portfolio"
                    ><i class="fa fa-eye"></i
                  ></a>
                  <a class="btn btn-lg-square rounded-circle mx-2" href=""
                    ><i class="fa fa-link"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 portfolio-item second wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div class="portfolio-inner rounded">
              <img
                class="img-fluid"
                src="img/work/project-tree.jpg"
                :alt="globalConfig.altPictureText"
              />
              <div class="portfolio-text">
                <h4 class="text-white mb-4">Rückschnitt von Pflanzen</h4>
                <div class="d-flex">
                  <a
                    class="btn btn-lg-square rounded-circle mx-2"
                    href="img/gazi2-square.png"
                    data-lightbox="portfolio"
                    ><i class="fa fa-eye"></i
                  ></a>
                  <a class="btn btn-lg-square rounded-circle mx-2" href=""
                    ><i class="fa fa-link"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 portfolio-item first wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="portfolio-inner rounded">
              <img
                class="img-fluid"
                src="img/work/project-wall.jpg"
                :alt="globalConfig.altPictureText"
              />
              <div class="portfolio-text">
                <h4 class="text-white mb-4">Mauerbau & Zaunbau</h4>
                <div class="d-flex">
                  <a
                    class="btn btn-lg-square rounded-circle mx-2"
                    href="img/work/wall.jpg"
                    data-lightbox="portfolio"
                    ><i class="fa fa-eye"></i
                  ></a>
                  <a class="btn btn-lg-square rounded-circle mx-2" href=""
                    ><i class="fa fa-link"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 portfolio-item second wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div class="portfolio-inner rounded">
              <img
                class="img-fluid"
                src="img/work/project-grass-1.jpg"
                :alt="globalConfig.altPictureText"
              />
              <div class="portfolio-text">
                <h4 class="text-white mb-4">Baumfällung</h4>
                <div class="d-flex">
                  <a
                    class="btn btn-lg-square rounded-circle mx-2"
                    href="img/work/project-grass-1.jpg"
                    data-lightbox="portfolio"
                    ><i class="fa fa-eye"></i
                  ></a>
                  <a class="btn btn-lg-square rounded-circle mx-2" href=""
                    ><i class="fa fa-link"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <!-- <div
            class="col-lg-4 col-md-6 portfolio-item first wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div class="portfolio-inner rounded">
              <img class="img-fluid" src="img/service-5.jpg" alt="" />
              <div class="portfolio-text">
                <h4 class="text-white mb-4">Green Technology</h4>
                <div class="d-flex">
                  <a
                    class="btn btn-lg-square rounded-circle mx-2"
                    href="img/service-5.jpg"
                    data-lightbox="portfolio"
                    ><i class="fa fa-eye"></i
                  ></a>
                  <a class="btn btn-lg-square rounded-circle mx-2" href=""
                    ><i class="fa fa-link"></i
                  ></a>
                </div>
              </div>
            </div>
          </div> -->
          <div
            class="col-lg-4 col-md-6 portfolio-item second wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="portfolio-inner rounded">
              <img
                class="img-fluid"
                src="img/work/project-lovor1.jpg"
                :alt="globalConfig.altPictureText"
              />
              <div class="portfolio-text">
                <h4 class="text-white mb-4">Stadtgärtnern</h4>
                <div class="d-flex">
                  <a
                    class="btn btn-lg-square rounded-circle mx-2"
                    href="img/work/lovor1.jpg"
                    data-lightbox="portfolio"
                    ><i class="fa fa-eye"></i
                  ></a>
                  <a class="btn btn-lg-square rounded-circle mx-2" href=""
                    ><i class="fa fa-link"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Projects End -->
  </div>
</template>

<script setup>
import config from '../../store/global.js';
const globalConfig = config.global().globalConfig;
</script>
